module.exports = __webpack_public_path__ + "img/036-aggregation.0ccedd94.png";